import { useCallback } from 'react';

import { useAppConfig } from 'state/appConfig';
import { trackEvent } from 'tracking/trackEvent';

/**
 * useInteractionTracking
 * Track button, link, radio clicks
 */
export const useInteractionTracking = (eventAction) => {
  const { channel } = useAppConfig();

  return useCallback(
    ({ onClick, onChange, tealiumData }) =>
      (...args) => {
        onClick && onClick(...args);
        onChange && onChange(...args);

        trackEvent({
          event_category: 'content',
          event_action: eventAction,
          ...tealiumData,
          event_content: `${channel.toLowerCase()}: chat assistant: ${
            tealiumData.event_content
          }`,
        });
      },

    [eventAction, channel],
  );
};
